import BasePage from '@/v2/views/components/BasePage'

import util from '../utils'
import { Notification } from 'element-ui';

// 系统管理
const SystemSchoolGroup = r => require(['@/pages/system/school/group'], r)		// 学校分组
const SystemStudentQRCode = r => require(['@/pages/system/student/qrcode'], r)	// 下载学生二维码
const SystemStudentImport = r => require(['@/pages/system/student/import'], r)	// 下载学生导入模板

const Student = r => require(['@/pages/system/student/index_xgk'], r)
const SystemParmAbility = r => require(['@/pages/system/parm/ability'], r)				// 能力点管理
const SystemStudent = r => require(['@/v2/views/system/student/index'], r)		// 学生管理
const SystemTeacher = r => require(['@/v2/views/system/teacher/index'], r)		// 教师管理
const SystemSchool = r => require(['@/v2/views/system/school/index'], r)		// 学校管理
// 系统基础参数管理
const SystemParmLayout = r => require(['@/v2/views/system/basic-param'], r)					// 基础参数管理
const SystemParmLevel = r => require(['@/v2/views/system/param_routers/score-level'], r)		// 分数等级设置
const SystemParmRatio = r => require(['@/v2/views/system/param_routers/ques-ratio'], r)					// 高频错题，薄弱知识点设置
const SystemParmCount = r => require(['@/v2/views/system/param_routers/paper-analysis'], r)					// 特殊考试参与统计设置
const SystemParmOther = r => require(['@/v2/views/system/param_routers/other-set'], r)
const SystemRegion = r => require(['@/v2/views/system/region/index'], r)    // 区域管理
const SystemRegionGroup = r => require(['@/v2/views/system/region/group'], r)    // 区域分组管理
const SystemMember = r => require(['@/v2/views/system/member'], r)				// 人员管理
const SystemRole = r => require(['@/v2/views/system/role'], r)			// 角色管理

function requireAuth (to, from, next) {
  if (!util.isLogin()) {
    next({
      path: '/login',
      query: { redirect: to.fullPath }
    })
  } else {
    if (to.meta.auth && !util.isAuth(to.meta.auth)) {
      const info = {
        title: "禁止访问！",
        message: "对不起，您没有本页访问权限",
        type: "error"
      }
      Notification(info);
    } else {
      next()
    }
  }
}
function isNotRequireAuth (to, from, next) {
  next()
}

export const system = {
  path: '/region/system',
  component: BasePage,
  beforeEnter: requireAuth,
  meta: { auth: 'Region-System' },
  children: [
    {
      path: '/region/system/region',
      component: SystemRegion
    },
    {
      path: '/region/system/region/group',
      component: SystemRegionGroup
    },
    {
      path: '/region/system/student',
      meta: { auth: 'Region-System-Student', keepAlive: true },
      component: SystemStudent
    },
    {
      path: "/region/system/student/xgk",
      component: Student,
      meta: { auth: "Region-System-Student", keepAlive: true }
    },
    {
      path: '/region/system/student/qrcode',
      component: SystemStudentQRCode
    },
    {
      path: '/region/system/student/import',
      component: SystemStudentImport
    },
    {
      path: '/region/system/role',
      meta: { auth: 'Region-System-Role' },
      component: SystemRole
    },
    {
      path: '/region/system/school',
      meta: { auth: 'Region-System-School' },
      component: SystemSchool
    },
    {
      path: '/region/system/school/group',
      // meta: {auth: 'Region-System-Class-Group'},
      component: SystemSchoolGroup
    },
    {
      path: '/region/system/member',
      meta: { auth: 'Region-System-Teacher', keepAlive: true },
      component: SystemMember
    },
    {
      path: '/region/system/teacher',
      meta: { auth: 'Region-System-Teacher', keepAlive: true },
      component: SystemTeacher
    },
    {
      path: '/region/system/parm',
      component: SystemParmLayout,
      meta: { auth: 'Region-System-Parm' },
      children: [
        {
          path: '/region/system/parm/level',
          meta: { auth: 'Region-System-Parm-Level' },
          component: SystemParmLevel
        },
        {
          path: '/region/system/parm/ratio',
          meta: { auth: 'Region-System-Parm-Ratio' },
          component: SystemParmRatio
        },
        {
          path: '/region/system/parm/count',
          meta: { auth: 'Region-System-Parm-Count' },
          component: SystemParmCount
        },
        {
          path: '/region/system/parm/ability',
          meta: { auth: 'Region-System-Parm-Ability' },
          component: SystemParmAbility
        },
        {
          path: '/region/system/parm/other',
          meta: { auth: 'Region-System-Parm-Other' },
          component: SystemParmOther
        }
      ]
    },
  ]
}


// WEBPACK FOOTER //
// ./src/router/system.js